
	import { Observer } from 'mobx-vue';
	import { Component, Prop, PropSync } from 'vue-property-decorator';
	import PrescriptionItem from '@/components/new-prescription/prescription-items/PrescriptionItem.vue';
	import PrescriptionItemSelect from '@/components/new-prescription/prescription-items/PrescriptionItemSelect.vue';
	import PrescriptionItemWrapper from '@/components/new-prescription/prescription-items/PrescriptionItemWrapper.vue';
	import PrescriptionItemRadio from '@/components/new-prescription/prescription-items/PrescriptionItemRadio.vue';

	@Observer
	@Component({
		components: { PrescriptionItemRadio, PrescriptionItemSelect, PrescriptionItemWrapper }
	})
	export default class PrescriptionItemRadioSelect extends PrescriptionItem {
		@PropSync('inputRadio', { required: true }) inputRadioValue!: string;
		@PropSync('inputSelect', { required: true }) inputSelectValue!: string;
		@Prop({ required: true }) radioValues!: {};
		@Prop({ required: true }) selectValues!: {};
		@Prop({ required: false, default: false }) selectDisabled!: boolean;
		@Prop({ required: false, default: false }) hideSelect!: boolean;
		//need to refactor this..
		beforeMount() {
			if (this.inputSelectValue === 'Consistent Shell Thickness') {
				this.inputSelectValue = 'consistent';
			}
			if (this.inputSelectValue === '2.5mm Shell Thickness') {
				this.inputSelectValue = '2.5mm';
			}
		}

		onChange() {
			// this is workaround for some cases in watchPrescription(), as there are fields (dropdowns on UI), that are null on init,
			// which are impossible to put reaction on, without major changes to default values
			this.$state.prescription.onPrescriptionChanged();
		}
	}
